package com.exura.pages.planCreator.components.seriesViews.sections

import androidx.compose.runtime.Composable
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorInputMode
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorTextArea
import com.exura.ui.TextStyles
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth


@Composable
internal fun DescriptionSeriesSection(
    value: String,
    onValueChange: (String) -> Unit,
    mode: PlanCreatorInputMode,
    placeholder: String,
    enabled: Boolean = true,
) = EditViewSection(
    enabled = enabled,
    title = "Opis",
) {
    PlanCreatorTextArea(
        value = value,
        onValueChange = onValueChange,
        mode = mode,
        placeholder = placeholder,
        modifier = Modifier.fillMaxWidth(),
        textStyle = TextStyles.normal14,
        maxLines = 3
    )
}
